import { formatDate } from '@angular/common';
import moment from 'moment';
import { UserRegion } from '../infrastructure/context/UserContext';
import { UserContextProvider } from '../infrastructure/context/user-context-provider';

const NA_DATE_FORMAT = 'MMM d, y';
const NA_DATEPICKER_FORMAT = 'MM/DD/YYYY';
const NA_DATETIME_FORMAT = 'MMM d, y, h:mm a';

const EU_DATE_FORMAT = 'd MMM y';
const EU_DATEPICKER_FORMAT = 'DD-MM-YYYY';
const EU_DATETIME_FORMAT = 'd MMM y, HH:mm';

export const getDatePickerDateFormat = (userContextProvider: UserContextProvider) => {
    let format = NA_DATEPICKER_FORMAT;
    if(userContextProvider.region == UserRegion.EU) {
        format = EU_DATEPICKER_FORMAT;
    }

    return {
        parse: {
          dateInput: format,
        },
        display: {
          dateInput: format,
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      };
}

export const getFormattedDateFromString = (date?: string, config?: any, includeTime?: boolean): string => {
    if(!date) {
        return '';
    }

    return getFormattedDate(new Date(date), config, includeTime);
}

export const getFormattedDate = (date?: Date, config?: any, includeTime?: boolean): string => {
    if(!date) {
        return '';
    }

    return includeTime ? date.toLocaleTimeString('en-us', config) : date.toLocaleDateString('en-us', config);
}

export const dateFormat = (date: string | Date | undefined, region: UserRegion | undefined, includeTime: boolean = false) => {
    try {
        if(date == null) {
            return '';
        }
    
        if(region == null) {
            return '';
        }
    
        let format;
        if(region == UserRegion.NA) {
            format = includeTime ? NA_DATETIME_FORMAT : NA_DATE_FORMAT;
        } else {
            format = includeTime ? EU_DATETIME_FORMAT : EU_DATE_FORMAT;
        }
    
        return formatDate(date, format, 'en-US', 'UTC');
    } catch (e) {
        console.error(e);
        return '';
    }
}

export const isPast = (date: string): boolean => {
    return moment(date).utc().isBefore(moment(), 'day');
}

export const isFuture = (date: string): boolean => {
    return moment(date).utc().isAfter(moment(), 'day');
}

export const isPastOrCurrent = (date: string): boolean => {
    return moment(date).utc().isSameOrBefore(moment(), 'day');
}

export const isCurrentOrFuture = (date: string): boolean => {
    return moment(date).utc().isSameOrAfter(moment(), 'day');
}

export const isCurrent = (date: string): boolean => {
    return moment(date).utc().isSame(moment(), 'day');
}